export class PricingAutomationApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** Flip the instant kill switch for a scope (compare-and-set on the store-level revision → 409 on conflict). */
    setKillSwitch(scope, killed) {
        return this.client.request({ method: 'POST', path: '/v1/pricing-automation/kill-switch', body: { scope, killed }, auth: true });
    }
    /** Read the current kill-switch state for a scope. D854: a never-set switch answers 200 with the default (live, revision 0) and `unset: true`; an older server answered 404. */
    getKillSwitch(scope) {
        return this.client.request({ method: 'GET', path: `/v1/pricing-automation/kill-switch?scope=${encodeURIComponent(scope)}`, auth: true });
    }
    /** Record a bounded, audited recommendation (the persisted kill switch overrides `input.killed` server-side). */
    recordDecision(input) {
        return this.client.request({ method: 'POST', path: '/v1/pricing-automation/decisions', body: input, auth: true });
    }
    /** List a scope's recorded recommendations (newest first). */
    listDecisions(scope) {
        return this.client.request({ method: 'GET', path: `/v1/pricing-automation/decisions?scope=${encodeURIComponent(scope)}`, auth: true });
    }
}
//# sourceMappingURL=pricing-automation.js.map